import { useProjectConfigContext } from "../contexts/ProjectConfigContext";
import { useGetLanguageApp } from "../stores/app.store";

export const useTags = () => {

    const { projectConfigState } = useProjectConfigContext();

    const currentLanguage = useGetLanguageApp();
    const projectId = projectConfigState.projectId;

    const generateTag = (langObj: object, path: string): string => {

        if(!langObj || !path) {
            return '';
        }

        const paths = path.split('.');
        let current: any = langObj;

        for (const p of paths) {
            if (current[p] === undefined) {
                return '';
            }

            current = current[p];
        }

        const currentLanguageTags = current[currentLanguage];

        return currentLanguageTags?.[projectId] ?? currentLanguageTags?.default ?? '';
    }

    return generateTag;
}

export default useTags;